import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { Case } from '../types';

interface DocumentManagementProps {
  caseData: Case;
  onUpdate: (updatedCase: Case) => void;
}

export const DocumentManagement: React.FC<DocumentManagementProps> = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 2 }}>
        <Typography variant="h6">Document Management</Typography>
        <Typography variant="body2" color="text.secondary">
          Document management functionality will be implemented here.
        </Typography>
      </Paper>
    </Box>
  );
};